/* Library */
import React, { Component } from 'react';
import ApplyCSS from '../../components/ApplyCSS';
import commonUtil from '../../utils/commonUtil';
import { constBrand } from '../../utils/clientConstant';
import serverClientUtil from '../../utils/serverClientUtil';

const _myVar = {};
_myVar.NODE_ENV = typeof env !== 'undefined' ? env.NODE_ENV : process.env.NODE_ENV;// eslint-disable-line no-undef
_myVar.PORT = typeof env !== 'undefined' ? env.PORT : process.env.PORT;// eslint-disable-line no-undef
const MY_VAR = typeof window !== 'undefined' ? window.env : (_myVar);


class Error404 extends Component {
  render() {
    const isLPBrand = commonUtil.getBrand() === constBrand.LP;
    return (
      <React.Fragment>
        <script dangerouslySetInnerHTML={{ __html: 'env = ' + (JSON.stringify(MY_VAR)) + '' }} />
        <ApplyCSS pageName="Page404" />
        <div className="error_img">
          <span className="txt_404">
            <h1 className={(isLPBrand ? 'error_404 pink' : 'error_404 grey')}>404</h1>
            <p className="error_desc"><b>¡Lo sentimos!</b> No encontramos la página <br /> que estabas buscando.</p>
            <p className="error_sub">Si necesitas ayuda comunícate al teléfono: <b>52 62 99 99</b> o en el Interior de la República al <b>01 800 7135555</b></p>
          </span>
          <span className="links">
            <a href={serverClientUtil.getMultiSiteURL(commonUtil.getBrand())} className={(isLPBrand ? 'pink' : 'grey')}>Regresar a Mesa de Regalos</a>
          </span>
        </div>
      </React.Fragment>

    );
  }
}

export default Error404;
